export default function ReviewsController($scope, $state, ReviewService, UtilService, OPTIONS, NotificationService, countryService) {
  var vm = this,
    ENTER_KEY = 13;

  //Pagination
  vm.maxSize = 5;
  vm.currentPage = 1;
  vm.totalItems = 0;

  vm.allReviewsSelectedPage = null;

  //Select options
  vm.options = {};
  vm.options.countries = {};
  vm.options.statuses = OPTIONS.statuses.reviews;
  vm.options.locales = OPTIONS.locales;
  vm.options.ratings = OPTIONS.reviews_ratings;
  vm.isLoading = false;

  vm.filterChanged = false;
  vm.filter = {
    merchantId: null,
    merchantCountry: 'DEU',
    filterRating: null,
    filterLocale: 'de',
    status: 'MANUAL_PROCESSING_REQUIRED',
    offset: 0,
    limit: 50,
  };

  vm.reviewsToBulkUpdate = [];
  vm.bulkUpdateStatus = null;
  vm.ratings = UtilService.generateRange('Rating', 6);

  vm.allReviewsSelected = false;
  vm.init = init;
  vm.searchReviews = searchReviews;
  vm.goToReview = goToReview;
  vm.updateReview = updateReview;
  vm.pageChanged = pageChanged;
  vm.calculatePagination = calculatePagination;
  vm.getCountries = getCountries;
  vm.toggleReviewToBulkUpdate = toggleReviewToBulkUpdate;
  vm.bulkUpdateReviews = bulkUpdateReviews;
  vm.sendReviewToOps = sendReviewToOps;

  vm.toggleAllReviewsToBulkUpdate = toggleAllReviewsToBulkUpdate;
  init();

  function init() {
    vm.getCountries();
  }

  function getCountries() {
    vm.isLoading = true;
    countryService
      .getAllCountries()
      .then(function(res) {
        if (res && res.data) {
          vm.options.countries = res.data;
        }
      })
      .finally(function() {
        vm.isLoading = false;
        vm.searchReviews();
      });
  }

  function searchReviews(resetPagination) {
    var searchUrl;

    if (vm.isLoading) {
      return;
    }

    vm.isLoading = true;

    if (resetPagination) {
      vm.calculatePagination();
    }

    searchUrl = UtilService.generateSearchUrl(vm.filter);

    ReviewService.searchReviews(searchUrl)
      .then(function(res) {
        vm.reviews = res.data.reviews;
        vm.totalItems = res.data.total;
        if (vm.filterChanged) {
          vm.filterChanged = false;
          resetBulkUpdate();
        } else {
          markReviewsSetToBulkUpdate();
        }
      })
      .finally(function() {
        vm.currentPage = resetPagination ? 1 : vm.currentPage;
        vm.isLoading = false;
      });
  }

  function resetBulkUpdate() {
    vm.reviewsToBulkUpdate = [];
    vm.bulkUpdateStatus = null;
  }

  function markReviewsSetToBulkUpdate() {
    var i, len, review;

    for (i = 0, len = vm.reviews.length; i < len; i++) {
      review = vm.reviews[i];
      if (vm.reviewsToBulkUpdate.indexOf(review.id) >= 0) {
        review.isSetToBulkUpdate = true;
      }
    }
  }

  function goToReview(review) {
    if (vm.isLoading || !review) {
      return;
    }

    $state.go('app.review.edit', {
      reviewId: review.id,
      review: review,
    });
  }

  function updateReview(review) {
    var reviewToUpdate;

    if (!review || vm.isLoading) {
      return;
    }

    vm.isLoading = true;
    reviewToUpdate = buildReviewToUpdate(review);

    ReviewService.updateReview(review.id, reviewToUpdate)
      .then(handleUpdateSuccess)
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function handleUpdateSuccess() {
    vm.isLoading = false;
    setTimeout(function() {
      vm.searchReviews();
    }, 1000);
    NotificationService.success('The review was successfully updated. Refreshing list.');
  }

  function pageChanged() {
    vm.calculatePagination();
    vm.searchReviews();
  }

  function calculatePagination() {
    vm.filter.offset = vm.currentPage * vm.filter.limit - vm.filter.limit;
  }

  function toggleReviewToBulkUpdate(id) {
    UtilService.toggleElementFromArray(vm.reviewsToBulkUpdate, id);
  }

  function toggleAllReviewsToBulkUpdate() {
    if (vm.allReviewsSelected) {
      vm.reviews.forEach(function(review) {
        review.isSetToBulkUpdate = false;
      });
      vm.reviewsToBulkUpdate = [];
      vm.allReviewsSelected = false;
    } else {
      vm.reviews.forEach(function(review) {
        UtilService.toggleElementFromArray(vm.reviewsToBulkUpdate, review.id);
        review.isSetToBulkUpdate = true;
      });
      vm.allReviewsSelected = true;
      vm.allReviewsSelectedPage = vm.currentPage;
    }
  }

  function buildReviewToUpdate(review) {
    return { status: review.status, rating: review.rating, description: review.description, locale: review.locale };
  }

  function bulkUpdateReviews() {
    if (!vm.bulkUpdateStatus || !vm.reviewsToBulkUpdate.length || vm.isLoading) {
      return;
    }
    vm.isLoading = true;

    ReviewService.updateReviews({ ids: vm.reviewsToBulkUpdate, status: vm.bulkUpdateStatus }).then(function() {
      NotificationService.success('Reviews were successfully updated');
      resetBulkUpdate();
      vm.isLoading = false;
      vm.searchReviews();
    });
  }

  function sendReviewToOps(reviewId) {
    vm.isLoading = true;
    ReviewService.sendReviewToOps(reviewId).then(function() {
      NotificationService.success('Review sent to Ops');
      vm.isLoading = false;
    });
  }

  vm.resetLocale = function() {
    if (vm.filter.merchantId) {
      vm.filter.merchantCountry = '';
      vm.filter.filterLocale = '';
      vm.filter.filterRating = '';
    }
  };

  vm.getReviewsForMerchantId = function(event) {
    if (event && event.keyCode === ENTER_KEY) {
      vm.resetLocale();
      vm.searchReviews(true);
    }
  };

  $scope.$watchGroup(['vm.filter.merchantCountry', 'vm.filter.filterRating', 'vm.filter.filterLocale', 'vm.filter.merchantId'], function(
    newValue,
    oldValue,
  ) {
    if (newValue !== oldValue) {
      vm.filterChanged = true;
    }
  });
}



// WEBPACK FOOTER //
// ./src/app/reviews/reviews.controller.js